export default {
  1: {
    firstGrade: '1° grado',
    secondGrade: '2° grado',
    thirdGrade: '3° grado',
    fourthGrade: '4° grado',
    fifthGrade: '5° grado',
    sixthGrade: '6° grado',
    firstYear: '1° año',
    secondYear: '2° año',
    thirdYear: '3° año',
    fourthYear: '4° año',
    firstYearBachelor: '1° año bachiller',
    secondYearBachelor: '2° año bachiller'
  },
  2: {
    firstGrade: '1° grado',
    secondGrade: '2° grado',
    thirdGrade: '3° grado',
    fourthGrade: '4° grado',
    fifthGrade: '5° grado',
    sixthGrade: '6° grado',
    seventhGrade: '7° grado',
    firstYear: '1° año',
    secondYear: '2° año',
    thirdYear: '3° año',
    fourthYear: '4° año',
    fifthYear: '5° año'
  },
  3: {
    firstGrade: '1° grado',
    secondGrade: '2° grado',
    thirdGrade: '3° grado',
    fourthGrade: '4° grado',
    fifthGrade: '5° grado',
    sixthGrade: '6° grado',
    firstYear: '1° año',
    secondYear: '2° año',
    thirdYear: '3° año',
    fourthYear: '4° año',
    fifthYear: '5° año',
    sixthYear: '6° año'
  },
  4: {
    firstGrade: '1° grado',
    secondGrade: '2° grado',
    thirdGrade: '3° grado',
    fourthGrade: '4° grado',
    fifthGrade: '5° grado',
    sixthGrade: '6° grado',
    seventhGrade: '7° grado',
    eighthGrade: '8° grado',
    ninethGrade: '9° grado',
    tenthGrade: '10° bachillerato',
    eleventhGrade: '11° bachillerato'
  },
  5: {
    firstGrade: '1° EBI',
    secondGrade: '2° EBI',
    thirdGrade: '3° EBI',
    fourthGrade: '4° EBI',
    fifthGrade: '5° EBI',
    sixthGrade: '6° EBI',
    seventhGrade: '7° EBI',
    eighthGrade: '8° EBI',
    ninethGrade: '9° EBI',
    firstYear: '1° EMS',
    secondYear: '2° EMS',
    thirdYear: '3° EMS'
  },
  6: {
    firstGrade: '1° grado',
    secondGrade: '2° grado',
    thirdGrade: '3° grado',
    fourthGrade: '4° grado',
    fifthGrade: '5° grado',
    sixthGrade: '6° grado',
    seventhGrade: '7° Ciclo básico',
    eighthGrade: '8° Ciclo básico',
    ninethGrade: '9° Ciclo básico',
    tenthGrade: '10° Ciclo diversificado',
    eleventhGrade: '11° Ciclo diversificado',
    twelfthGrade: '11° Ciclo diversificado'
  },
  7: {
    firstGrade: '1° Educación básica',
    secondGrade: '2° Educación básica',
    thirdGrade: '3° Educación básica',
    fourthGrade: '4° Educación básica',
    fifthGrade: '5° Educación básica',
    sixthGrade: '6° Educación básica',
    seventhGrade: '7° Educación básica',
    eighthGrade: '8° Educación básica',
    firstYear: '1° Educación media',
    secondYear: '2° Educación media',
    thirdYear: '3° Educación media',
    fourthYear: '4° Educación media'
  },
  8: {
    firstGrade: '1° grado',
    secondGrade: '2° grado',
    thirdGrade: '3° grado',
    fourthGrade: '4° grado',
    fifthGrade: '5° grado',
    sixthGrade: '6° grado',
    firstYear: '1° año',
    secondYear: '2° año',
    thirdYear: '3° año',
    fourthYear: '4° año',
    fifthYear: '5° año'
  }
}

export const en = {
  1: {
    firstGrade: '1° grade',
    secondGrade: '2° grade',
    thirdGrade: '3° grade',
    fourthGrade: '4° grade',
    fifthGrade: '5° grade',
    sixthGrade: '6° grade',
    firstYear: '1° year',
    secondYear: '2° year',
    thirdYear: '3° year',
    fourthYear: '4° year',
    firstYearBachelor: '1° year bachelor',
    secondYearBachelor: '2° year bachelor'
  },
  2: {
    firstGrade: '1° grade',
    secondGrade: '2° grade',
    thirdGrade: '3° grade',
    fourthGrade: '4° grade',
    fifthGrade: '5° grade',
    sixthGrade: '6° grade',
    seventhGrade: '7° grade',
    firstYear: '1° year',
    secondYear: '2° year',
    thirdYear: '3° year',
    fourthYear: '4° year',
    fifthYear: '5° year'
  },
  3: {
    firstGrade: '1° grade',
    secondGrade: '2° grade',
    thirdGrade: '3° grade',
    fourthGrade: '4° grade',
    fifthGrade: '5° grade',
    sixthGrade: '6° grade',
    firstYear: '1° year',
    secondYear: '2° year',
    thirdYear: '3° year',
    fourthYear: '4° year',
    fifthYear: '5° year',
    sixthYear: '6° year'
  },
  4: {
    firstGrade: '1° grade',
    secondGrade: '2° grade',
    thirdGrade: '3° grade',
    fourthGrade: '4° grade',
    fifthGrade: '5° grade',
    sixthGrade: '6° grade',
    seventhGrade: '7° grade',
    eighthGrade: '8° grade',
    ninethGrade: '9° grade',
    tenthGrade: '10° bachelor',
    eleventhGrade: '11° bachelor'
  },
  5: {
    firstGrade: '1° EBI',
    secondGrade: '2° EBI',
    thirdGrade: '3° EBI',
    fourthGrade: '4° EBI',
    fifthGrade: '5° EBI',
    sixthGrade: '6° EBI',
    seventhGrade: '7° EBI',
    eighthGrade: '8° EBI',
    ninethGrade: '9° EBI',
    firstYear: '1° EMS',
    secondYear: '2° EMS',
    thirdYear: '3° EMS'
  },
  6: {
    firstGrade: '1° grade',
    secondGrade: '2° grade',
    thirdGrade: '3° grade',
    fourthGrade: '4° grade',
    fifthGrade: '5° grade',
    sixthGrade: '6° grade',
    seventhGrade: '7° Ciclo básico',
    eighthGrade: '8° Ciclo básico',
    ninethGrade: '9° Ciclo básico',
    tenthGrade: '10° Ciclo diversificado',
    eleventhGrade: '11° Ciclo diversificado',
    twelfthGrade: '11° Ciclo diversificado'
  },
  7: {
    firstGrade: '1° Educación básica',
    secondGrade: '2° Educación básica',
    thirdGrade: '3° Educación básica',
    fourthGrade: '4° Educación básica',
    fifthGrade: '5° Educación básica',
    sixthGrade: '6° Educación básica',
    seventhGrade: '7° Educación básica',
    eighthGrade: '8° Educación básica',
    firstYear: '1° Educación media',
    secondYear: '2° Educación media',
    thirdYear: '3° Educación media',
    fourthYear: '4° Educación media'
  },
  8: {
    firstGrade: '1° grade',
    secondGrade: '2° grade',
    thirdGrade: '3° grade',
    fourthGrade: '4° grade',
    fifthGrade: '5° grade',
    sixthGrade: '6° grade',
    firstYear: '1° year',
    secondYear: '2° year',
    thirdYear: '3° year',
    fourthYear: '4° year',
    fifthYear: '5° year'
  }
}

export const ca = {
  1: {
    firstGrade: '1° grau',
    secondGrade: '2° grau',
    thirdGrade: '3° grau',
    fourthGrade: '4° grau',
    fifthGrade: '5° grau',
    sixthGrade: '6° grau',
    firstYear: '1° any',
    secondYear: '2° any',
    thirdYear: '3° any',
    fourthYear: '4° any',
    firstYearBachelor: '1° any batxiller',
    secondYearBachelor: '2° any batxiller'
  },
  2: {
    firstGrade: '1° grau',
    secondGrade: '2° grau',
    thirdGrade: '3° grau',
    fourthGrade: '4° grau',
    fifthGrade: '5° grau',
    sixthGrade: '6° grau',
    seventhGrade: '7° grau',
    firstYear: '1° any',
    secondYear: '2° any',
    thirdYear: '3° any',
    fourthYear: '4° any',
    fifthYear: '5° any'
  },
  3: {
    firstGrade: '1° grau',
    secondGrade: '2° grau',
    thirdGrade: '3° grau',
    fourthGrade: '4° grau',
    fifthGrade: '5° grau',
    sixthGrade: '6° grau',
    firstYear: '1° any',
    secondYear: '2° any',
    thirdYear: '3° any',
    fourthYear: '4° any',
    fifthYear: '5° any',
    sixthYear: '6° any'
  },
  4: {
    firstGrade: '1° grau',
    secondGrade: '2° grau',
    thirdGrade: '3° grau',
    fourthGrade: '4° grau',
    fifthGrade: '5° grau',
    sixthGrade: '6° grau',
    seventhGrade: '7° grau',
    eighthGrade: '8° grau',
    ninethGrade: '9° grau',
    tenthGrade: '10° batxiller',
    eleventhGrade: '11° batxiller'
  },
  5: {
    firstGrade: '1° EBI',
    secondGrade: '2° EBI',
    thirdGrade: '3° EBI',
    fourthGrade: '4° EBI',
    fifthGrade: '5° EBI',
    sixthGrade: '6° EBI',
    seventhGrade: '7° EBI',
    eighthGrade: '8° EBI',
    ninethGrade: '9° EBI',
    firstYear: '1° EMS',
    secondYear: '2° EMS',
    thirdYear: '3° EMS'
  },
  6: {
    firstGrade: '1° grau',
    secondGrade: '2° grau',
    thirdGrade: '3° grau',
    fourthGrade: '4° grau',
    fifthGrade: '5° grau',
    sixthGrade: '6° grau',
    seventhGrade: '7° Ciclo básico',
    eighthGrade: '8° Ciclo básico',
    ninethGrade: '9° Ciclo básico',
    tenthGrade: '10° Ciclo diversificado',
    eleventhGrade: '11° Ciclo diversificado',
    twelfthGrade: '11° Ciclo diversificado'
  },
  7: {
    firstGrade: '1° Educación básica',
    secondGrade: '2° Educación básica',
    thirdGrade: '3° Educación básica',
    fourthGrade: '4° Educación básica',
    fifthGrade: '5° Educación básica',
    sixthGrade: '6° Educación básica',
    seventhGrade: '7° Educación básica',
    eighthGrade: '8° Educación básica',
    firstYear: '1° Educación media',
    secondYear: '2° Educación media',
    thirdYear: '3° Educación media',
    fourthYear: '4° Educación media'
  },
  8: {
    firstGrade: '1° grau',
    secondGrade: '2° grau',
    thirdGrade: '3° grau',
    fourthGrade: '4° grau',
    fifthGrade: '5° grau',
    sixthGrade: '6° grau',
    firstYear: '1° any',
    secondYear: '2° any',
    thirdYear: '3° any',
    fourthYear: '4° any',
    fifthYear: '5° any'
  }
}
